import styled from "styled-components";
export const UiDropdown = styled.div`
	display: block;
	width: max-content;
`;